<main class="d-flex flex-column flex-grow-1 h-100">
  <div class="gw-header d-flex align-items-center gap-2 sticky-sm-top">
    <div class="flex-grow-1">
      <a href="{{ homeUrl }}">
        <img class="logo" height="70px" alt="Groundworks Jobs" src="logo+install-management.png" />
      </a>
    </div>
    <div class="text-center">
      <span class="fw-normal" id="selected-branch">{{ selectedBranch }}</span>
    </div>
    <div class="flex-grow-1 d-flex justify-content-end align-items-center user-details-wrapper">
      <div class="user-details">
        <div class="user-name">
          @if(!production) {
          <span class="badge badge-pill bg-danger" id="environment-badge">{{ env }}</span>
          }
          <span class="dropdown">
            <button class="btn btn-link dropdown-toggle" data-bs-toggle="dropdown" data-bs-auto-close="true"
              aria-expanded="false">
              {{ whoami }}
            </button>
            <div class="dropdown-menu" style="z-index: 1100">
              <button class="dropdown-item" (click)="logout()">Logout</button>
            </div>
          </span>
        </div>
        <div class="user-image"></div>
      </div>
    </div>
  </div>
  <router-outlet />
</main>
